
import { WalletIncrementsResponse } from "../models/bmp.model";
import { responseHero } from "../utils/axiosInterceptor";

export const getBMPWalletIncreasements = (): Promise<WalletIncrementsResponse | null> => {
    return new Promise<WalletIncrementsResponse | null>((resolve, reject) => {
        responseHero.get(`${process.env.REACT_APP_API_URL}/bmp/monthly/deposits`).then((response) => {
            resolve(response.data as WalletIncrementsResponse | null);
        })
        .catch(error => {
            console.error(error);
            reject(error);
        });
    });
};